import { GridPreferencePanelsValue as MUIGridPreferencePanelsValue } from '@mui/x-data-grid-premium';

export const GridPreferencePanelsValue = MUIGridPreferencePanelsValue;
